import {
  SET_CAN_CONTINUE_FALSE,
  SET_CAN_CONTINUE_TRUE
} from './CanContinueActions';

export const canContinueReducer = (state=false, action) => {
  const { type } = action;
  switch (type){
  case SET_CAN_CONTINUE_FALSE:{
    return false
  }
  case SET_CAN_CONTINUE_TRUE:{
    return true
  }
  default:{
    return state;
  }
  }
}